import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'

import {
  GALLERY_ASPECT_RATIO,
  SLIDER_IMAGE_BASE_CLASS,
  SLIDER_IMAGE_DESIGNS,
  SLIDER_IMAGE_SINGLE_CLASS,
  SLIDER_IMAGE_WIDE_CLASS
} from '../../config.js'

const Image = ({aspectRatio, image, index, sliderImageDesign, hasSingleImage, currentSlide}) => {
  if (image === undefined) return null

  const {alt, fetchpriority, key: imageKey, src, title} = image
  const key = imageKey ? imageKey + index : index
  const imageDesign = SLIDER_IMAGE_DESIGNS[sliderImageDesign]
  const isWideAspectRatio = aspectRatio === GALLERY_ASPECT_RATIO.wideScreen

  const SLIDER_IMAGE_CLASS = cx(SLIDER_IMAGE_BASE_CLASS, `${SLIDER_IMAGE_BASE_CLASS}--${imageDesign}`, {
    [SLIDER_IMAGE_SINGLE_CLASS]: hasSingleImage,
    [SLIDER_IMAGE_WIDE_CLASS]: isWideAspectRatio
  })

  return (
    <AtomImage
      alt={alt}
      className={SLIDER_IMAGE_CLASS}
      key={key}
      fetchpriority={fetchpriority}
      src={src}
      title={title}
    />
  )
}

Image.displayName = 'Image'
Image.propTypes = {
  aspectRatio: PropTypes.string,
  hasSingleImage: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentSlide: PropTypes.number,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    key: PropTypes.string,
    title: PropTypes.string,
    fetchpriority: PropTypes.string
  }).isRequired,
  sliderImageDesign: PropTypes.oneOf(Object.values(SLIDER_IMAGE_DESIGNS))
}

export default Image
